<template>
  <div class="mobile_wrap_shooting_common wow fadeInUp">
    <el-row>
      <el-col :span="1" class="header_block"></el-col>
      <el-col :span="22" class="header_block" style="background:#fff">
        <div class="shooting_one" ref="shooting_one">
          <img ref="shooting_img" :src="require('@/assets/imgs/shooting001.jpeg')" class="shoot_img" />
        </div>
        <div v-for="(item,index) in shootingArray" :key="index" class="shooting_one shooting_each" :class="index<=3?'mgb10':''">
          <img ref="shooting_img" :src="item.url" class="shoot_img" />
        </div>
      </el-col>
      <el-col :span="1" class="header_block"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "shooting",
  data() {
    return {
      shootingArray: [
        // {url:require('@/assets/imgs/shooting01.jpeg'),cName:'shooting_one'},
        {
          url: require("@/assets/imgs/shooting02.jpg"),
          cName: "shooting_two"
        },
        {
          url: require("@/assets/imgs/shooting03.jpg"),
          cName: "shooting_three"
        },
        {
          url: require("@/assets/imgs/shooting04.jpg"),
          cName: "shooting_three"
        },
        {
          url: require("@/assets/imgs/shooting05.jpg"),
          cName: "shooting_two"
        },
        {
          url: require("@/assets/imgs/shooting06.jpg"),
          cName: "shooting_one"
        },
        {
          url: require("@/assets/imgs/shooting07.jpg"),
          cName: "shooting_one"
        },
        {
          url: require("@/assets/imgs/shooting08.jpg"),
          cName: "shooting_two"
        },
      ]
    };
  },
  

  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
    setTimeout(() => {
      let initHeight = this.$refs.shooting_one.clientHeight;
      console.log(initHeight, "1111");
      console.log(this.$refs.shooting_img, "9090");
      for (let i = 0; i < this.$refs.shooting_img.length; i++) {
        this.$refs.shooting_img[i].style.height = initHeight + "px";
      }
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mobile_wrap_shooting_common {
  .header_block {
    min-height: 10px;
  }
  .shooting_one {
    width: calc((100% - 15px) * 0.25);
    margin-right: 5px ;
    float: left;
  }
  .shooting_each:nth-child(4){
margin-right: 0px ;
  }
  .shooting_each:nth-child(8){
margin-right: 0px ;
  }
  .mgb10{
    margin-bottom: 5px;
  }
  // .shooting_two {
  //   width: calc((100% - 40px) * 0.3);
  //   margin: 10px 0 0 10px;
  //   float: left;
  // }
  // .shooting_three {
  //   width: calc((100% - 40px) * 0.25);
  //   margin: 10px 0 0 10px;
  //   float: left;
  // }
  .shoot_img {
    width: 100%;
  }
}
</style>



